<template>
  <div id="">
    <div class="emd-stripe">
      <div class="emd-bounds">
        <div class="emd-section fade-in">
          <div v-if="isLoading && !requestFailed" class="emd-box _state_loading"></div>
          <p v-else-if="!isLoading && requestFailed" class="emd-text _color_danger _align_center">{{$t('edit.error')}}</p>
          <div v-else class="emd-box">
            <EmdBoxHeader :title="$t('breadcrumb.edit.keys')" />
            <div class="emd-box__content">
              <form>
                <fieldset>
                  <div class="emd-flex _direction_column _direction_row_md">
                    <div class="emd-flex-item _grow_1">
                      <div class="emd-chunk">
                        <div class="emd-form-group">
                          <label class="emd-label" for="pk">Public key:
                          </label>
                          <input class="emd-input" id="pk" type="text" disabled v-model="publicAppKey" @copy="sendFsEvent('copiar-public-key')">
                          <p class="emd-input-helper">{{$t('edit.form.keys.publicKey_helper')}}</p>
                        </div>
                      </div>
                    </div>
                    <div class="emd-flex-item _grow_1">
                      <div class="emd-chunk">
                        <div class="emd-form-group">
                          <label class="emd-label" for="sk">Secret key:
                          </label>
                          <input class="emd-input" id="sk" type="text" disabled v-model="secretAppKey" @copy="sendFsEvent('copiar-secret-key')">
                          <p class="emd-input-helper">{{$t('edit.form.keys.secretKey_helper')}}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </fieldset>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import EmdBoxHeader from '@/components/emerald/EmdBoxHeader'
import sendFsCustomEvent from '@/mixins/sendFsCustomEvent'
export default {
  name: 'ApplicationKeys',
  components: {
    EmdBoxHeader
  },
  mixins: [sendFsCustomEvent],
  computed: {
    isLoading () {
      return this.$store.state.application.detail.isLoading
    },
    requestFailed () {
      return this.$store.state.application.detail.requestFailed
    },
    publicAppKey: {
      get () {
        return this.$store.state.application.detail.public_app_key
      }
    },
    secretAppKey: {
      get () {
        return this.$store.state.application.detail.secret_app_key
      }
    }
  },
  data () {
    return {}
  }
}
</script>
<style scoped>
.emd-box._state_loading {
  height: 210px;
  background-repeat: no-repeat;
  background-image: linear-gradient(#f4f4f4), linear-gradient(#f4f4f4), linear-gradient(#f4f4f4), linear-gradient(#f4f4f4), linear-gradient(#f4f4f4);
  background-size:
    15% 25px,
    8% 20px,
    48% 20%,
    48% 20%,
    8% 20px;
  background-position:
    2% 9%,
    1.75% 35%,
    3% 55%,
    97.5% 55%,
    55% 35%;
  opacity: 1;
  animation: opacity 1s infinite ease-in;
}
</style>
